/// <amd-module name="Tfs/Header/Components/HeaderBreadcrumbService" />
import * as React from "react";

import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { IVssPageService } from "VSS/Platform/Page";

import { IBreadcrumbItem } from "VSSUI/Breadcrumb";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";

import { ITfsPageService } from "Tfs/Platform/Page";

/**
 * Service for creating breadcrumb items.
 */
class HeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {
    public getBreadcrumbItems(breadcrumbId: string): IBreadcrumbItem[] {
        const items: IBreadcrumbItem[] = [];

        // Collection
        const pageService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();
        if (pageData) {
            items.push({
                key: "Collection",
                text: pageData.hostName,
                href: pageData.hostPath,
                rank: 10
            });
        }

        // Project
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            const projectHref = tfsPageData.project.url;
            items.push({
                key: "Project",
                text: tfsPageData.project.name,
                href: projectHref,
                onClick: (event: React.MouseEvent<HTMLElement>) => {
                    this._onFPSItemClick(event, projectHref || "", "ms.vss-web.home-hub-group");
                },
                rank: 20
            });
        }

        const navigationService = this.pageContext.getService<IVssNavigationService>("IVssNavigationService");
        const displayedNavigation = navigationService.getDisplayedNavigation();
        const hubGroupNavigation = navigationService.getNavigation(displayedNavigation[2]);
        const hubNavigation = navigationService.getNavigation(displayedNavigation[3]);

        // Hub Group
        if (hubGroupNavigation !== undefined && hubGroupNavigation.name) {
            items.push({
                key: "HubGroup",
                text: hubGroupNavigation.name,
                href: hubGroupNavigation.href,
                onClick: (event: React.MouseEvent<HTMLElement>) => {
                    // If the hub group and hub entries are the same, use the hub id as the navigationId
                    // here so that the nav avoids the re-layout (and flickering).
                    const navigationId = hubNavigation && hubNavigation.href === hubGroupNavigation.href ? hubNavigation.id : hubGroupNavigation.id;
                    this._onFPSItemClick(event, hubGroupNavigation.href || "", navigationId);
                },
                rank: 30
            });
        }

        // Hub
        if (hubNavigation !== undefined && hubNavigation.parentId && hubNavigation.name) {
            items.push({
                key: "Hub",
                text: hubNavigation.name,
                href: hubNavigation.href,
                onClick: (event: React.MouseEvent<HTMLElement>) => {
                    this._onFPSItemClick(event, hubNavigation.href || "", hubNavigation.id);
                },
                rank: 40
            });
        }

        return items;
    }

    private _onFPSItemClick = (event: React.MouseEvent<HTMLElement>, href: string, navigationId?: string) => {
        onClickFPS(this.pageContext, href, true, event, { telemetrySource: "headerBreadcrumb", navigationId: navigationId });
    };
}

Services.add("header-breadcrumb-service", { serviceFactory: HeaderBreadcrumbService });
